
import BstlArtikel from "@/entities/common/bstl_artikel"
import ShoppingLogic from "@/logic/bestellung_neu/shopping_logic"
import Component from "vue-class-component"
import { Vue } from "vue-property-decorator"
import NichtGueltig from "../custom/NichtGueltig.vue"

@Component({ components: { NichtGueltig } })
export default class ShoppingArtikel extends Vue {
  logic?: ShoppingLogic = null

  added(value: BstlArtikel) {
    this.logic.addArtikel(value)
  }
}
